import React from 'react';
import SurfboardItem from '../surfboards/SurfboardItem';

const Body = () => {
    return (
        <div className="container bg-primary">
            <SurfboardItem />
        </div>
    )
}

export default Body;